import type { SearchInsuranceType } from "../schema";

/**
 * Stable DOM id for the firstname field shown during ambiguous patient lookup.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const id = CHECKIN_PATIENT_LOOKUP_FIRSTNAME_ID;
 * ```
 */
export const CHECKIN_PATIENT_LOOKUP_FIRSTNAME_ID =
  "frontdesk-patient-lookup-firstname-input";

/**
 * Privacy-safe state for manual check-in patient lookup.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const state: CheckInPatientLookupSearchState = { status: "idle" };
 * ```
 */
export interface CheckInPatientLookupSearchState {
  status: "idle" | "searching" | "found" | "ambiguous" | "not_found" | "error";
  patientId?: string;
  insurance?: SearchInsuranceType;
  hint?: "firstname" | "additional";
  message?: string;
}
